import { cloneElement, memo, ReactElement } from "react";
import classnames from "classnames";

import styles from "./style.module.scss";

export type CircularProgressProps = {
  value: number
  size?: number,
  strokeWidth?: number,
  className?: string,
  backgroundClassName?: string
  textClassName?: string,
  successIcon?: ReactElement<{ className?: string; x?: string; y?: string }>
}

export const CircularProgress = memo<CircularProgressProps>((
  {
    value,
    size = 120,
    strokeWidth = 8,
    className,
    backgroundClassName,
    textClassName,
    successIcon,
  }) => {

  const radius = (size - strokeWidth) / 2;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - dashArray * value;
  const completed = value === 1;

  return (
    <svg
      className={classnames(className, styles.root, { [styles.completed]: completed })}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}>
      <circle
        className={classnames(styles.background, backgroundClassName)}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />
      <circle
        className={styles.progress}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{
          strokeDasharray: dashArray,
          strokeDashoffset: dashOffset,
        }} />
      <text
        className={classnames(styles.text, textClassName)}
        x="50%"
        y="50%"
        dy=".3em"
        textAnchor="middle">
        {`${(value * 100).toFixed(0)}%`}
      </text>
      {
        successIcon ?
          cloneElement(successIcon, {
            className: styles.successIcon,
            x: "50%",
            y: "50%",
          })
          :
          <path
            className={styles.successIcon}
            transform={`scale(${size / 120 * 5})`}
            x="50%"
            y="50%"
            d="M9.29 16.29L5.7 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z"
          />
      }

    </svg>
  );
});

export default CircularProgress;
